import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      overflow: 'hidden',
      fontSize: 16,
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.primary,
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
      },
      '&.center': {
        textAlign: 'center',
      },
      '&.right': {
        textAlign: 'right',
      },
      '&:before': {
        content: "''",
        display: 'inline-block',
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        width: '100%',
        height: 1,
        background: theme.palette.grey.A200,
        border: `solid ${theme.palette.common.white}`,
        borderWidth: '0 5px',
        marginLeft: '-100%',
      },
      '&:after': {
        content: "''",
        display: 'inline-block',
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        width: '100%',
        height: 1,
        background: theme.palette.grey.A200,
        border: `solid ${theme.palette.common.white}`,
        borderWidth: '0 5px',
        marginRight: '-100%',
      },
    },
  }),
);

interface Props {
  position?: 'left' | 'center' | 'right';
  className?: string;
}

const TitleWithLine: React.FC<Props> = ({ children, position = 'left', className }) => {
  const classes = useStyles();

  return <div className={clsx(classes.root, position, className)}>{children}</div>;
};

export default TitleWithLine;
